var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpvioLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 42,
    viewBox: "0 0 150 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4481_41357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.6286 22.2074H18.9708C19.4821 22.2074 19.7993 21.6607 19.545 21.2254L13.8739 11.5196C13.6196 11.0817 12.9798 11.0817 12.7255 11.5196L7.05441 21.2254C6.80009 21.6633 7.11734 22.2074 7.6286 22.2074Z",
    fill: "#5F20BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90906 23.3138C6.65474 22.8759 6.015 22.8759 5.76068 23.3138L0.0895685 33.0196C-0.164753 33.4575 0.152493 34.0016 0.663759 34.0016H12.006C12.5173 34.0016 12.8345 33.4549 12.5802 33.0196L6.90906 23.3138Z",
    fill: "#5F20BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8348 23.3138C20.5805 22.8759 19.9408 22.8759 19.6865 23.3138L14.0153 33.0196C13.761 33.4575 14.0783 34.0016 14.5895 34.0016H25.9318C26.443 34.0016 26.7603 33.4549 26.506 33.0196L20.8348 23.3138Z",
    fill: "#5F20BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7743 24.7466C51.7743 26.1716 51.2787 27.3194 50.4843 28.1097C49.6899 28.8999 48.573 29.356 47.2935 29.356C45.9406 29.356 44.7896 28.8974 43.9794 28.1071C43.1693 27.3169 42.6737 26.1716 42.6737 24.7466V11.2864H37.1914V24.389C37.1914 27.4283 38.2637 29.9519 40.0807 31.7164C41.895 33.4782 44.4225 34.4602 47.2909 34.4602C50.1592 34.4602 52.6002 33.4782 54.4066 31.7164C56.2157 29.9519 57.3012 27.4309 57.3012 24.3916V11.2864H51.7743V24.7466Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.14 25.213L93.8942 11.2864H87.9609L99.0803 34.4602H101.201L112.274 11.2864H106.34L100.14 25.213Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7019 10.7966C72.7759 10.7966 70.1382 11.8149 68.3763 13.6649V11.2863H63.1641V42H68.691V31.8666C70.4948 33.5274 72.9437 34.4602 75.7019 34.4602C82.2198 34.4602 86.9759 29.3533 86.9759 22.6064C86.9759 15.8594 82.2198 10.7966 75.7019 10.7966ZM74.9336 15.8568C78.5335 15.8568 81.3127 18.6499 81.3127 22.6504C81.3127 26.6509 78.4915 29.4 74.9336 29.4C73.2845 29.4 71.7166 28.8403 70.563 27.7262C69.4146 26.6172 68.6438 24.9253 68.6438 22.6064C68.6438 20.2874 69.412 18.6318 70.563 17.5254C71.7166 16.4165 73.2845 15.8568 74.9336 15.8568Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.066 11.2864H115.539V33.9679H121.066V11.2864Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.328 0C116.317 0 114.684 1.54682 114.684 3.5108C114.684 5.47477 116.322 6.97755 118.328 6.97755C120.334 6.97755 121.925 5.47995 121.925 3.5108C121.925 1.54164 120.297 0 118.328 0V0Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.821 10.7967C131.248 10.7086 125.6 16.0927 125.737 22.6065C125.6 29.0244 131.243 34.595 137.824 34.4603C144.491 34.5924 150.136 29.027 150 22.6065C150.136 16.1834 144.488 10.662 137.821 10.7967ZM137.821 29.356C134.171 29.356 131.353 26.5111 131.353 22.6505C131.353 18.7899 134.177 15.8569 137.866 15.8569C141.555 15.8569 144.334 18.7873 144.334 22.6505C144.334 26.5137 141.513 29.356 137.818 29.356H137.821Z",
    fill: "#101010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4481_41357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 42,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpvioLogo);
export default __webpack_public_path__ + "static/media/upvio-logo.43130068643a88008db3520727abeeb1.svg";
export { ForwardRef as ReactComponent };